import Houdini from "houdinijs";
const $ = require("jquery");

$(document).ready(function() {
  const accordionList = document.querySelector(".accordion-large__list");

  if (accordionList === null) {
    return;
  }

  new Houdini("[data-houdini-dl] dd", {
    isAccordion: true,
    collapseOthers: true,
    headingClass: "accordion-large__item__header",
    btnClass: "accordion-large__item__title",
    icon: false
  });
});
